/* eslint-disable camelcase */
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import './antd.less'
import './i18n'
import Routes from './routes'
import Loader, { LoaderContainer } from 'components/Loader'
import { ApolloClient, ApolloProvider, InMemoryCache, from } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { onError } from '@apollo/client/link/error'
import { GlobalStyle } from 'globals/styles'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { setContext } from '@apollo/client/link/context'
import BugsnagErrorBoundary from 'components/Bugsnag'

let react_app_endpoint:string = process.env.REACT_APP_GRAPHQL_ENDPOINT_FR!

if (window.location.host === process.env.PARTNER_AREA_HOSTNAME_FR) {
  react_app_endpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT_FR!
} else if (window.location.host === process.env.PARTNER_AREA_HOSTNAME_BE) {
  react_app_endpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT_BE!
}

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers
    }
  }
})

const uploadLink = createUploadLink({
  uri: react_app_endpoint,
  credentials: 'include',
  headers: {
    'X-Partner-JWT-Token': localStorage.getItem('token') || ''
  }
})

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      if (message === 'unauthorized-mfa' && window.location.pathname !== '/mfa') {
        window.location.href = '/mfa'
      }
      if (message === 'unauthorized-session' && window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
      if (message === 'invalid-authencity-token') {
        window.location.href = '/login'
      }
    })
  }
})

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([errorLink, authLink.concat(uploadLink)]),
  connectToDevTools: process.env.REACT_APP_ENVIRONMENT === 'development'
})

ReactDOM.render(
    <React.StrictMode>
      <React.Suspense fallback={
        <LoaderContainer>
          <Loader extend />
        </LoaderContainer>
      }>
        <BugsnagErrorBoundary>
          <GlobalStyle />
          <ApolloProvider client={apolloClient}>
            <Routes />
          </ApolloProvider>
        </BugsnagErrorBoundary>
      </React.Suspense>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
